import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getRouteApi } from "@tanstack/react-router";
import { toast } from "sonner";
import { apiClient } from "~/lib/client"

import { handleError } from "~/utils/response"
import { handleResponse } from "~/utils/response"
import { encountersKeys, paymentsKeys } from "../queries";
import { quickActionsKeys } from "../../../quick-actions/api/queries";
import { getApiProgram } from "~/lib/utils";

export const useCreateAppointmentMutation = () => {
    const queryClient = useQueryClient();
    return useMutation<unknown, unknown, unknown>({
        mutationFn: async (variables: unknown) => {
            try {
                const response = await apiClient("/admin/appointments", {
                    method: "POST",
                    body: JSON.stringify(variables),
                });

                return await handleResponse(response);
            } catch (error) {
                return handleError(error);
            }
        },
        onSuccess: () => {
            toast.success("Appointment created successfully!");
            queryClient.invalidateQueries({ queryKey: encountersKeys.all });
            queryClient.invalidateQueries({ queryKey: quickActionsKeys.all });
        }
    });
};

export const useSendInvoiceMutation = () => {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program")
    const { program } = routeApi.useParams()
    const apiProgram = getApiProgram(program);
    const queryClient = useQueryClient()
    return useMutation<
        unknown, // Response type (customize as needed)
        unknown, // Error type (customize as needed)
        { patient_id: string; type_id: string; type: string;[key: string]: any } // Variables type
    >({
        mutationFn: async ({ patient_id, type_id, type, ...rest }) => {
            try {
                const response = await apiClient(
                    `/admin/payments/${patient_id}/invoice/${type_id}?type=${encodeURIComponent(type)}`,
                    {
                        method: "POST",
                        body: JSON.stringify(rest),
                    }
                );
                return await handleResponse(response);
            } catch (error) {
                return handleError(error);
            }
        },
        onSuccess: () => {
            // queryClient.clear();
            // navigate({ to: "/", search: { redirect: "/dashboard" } });
            toast.success("Invoice sent successfully!");
            queryClient.invalidateQueries({ queryKey: paymentsKeys.payments({ program: apiProgram }) });
            queryClient.invalidateQueries({ queryKey: encountersKeys.all });
            queryClient.invalidateQueries({ queryKey: quickActionsKeys.all });
        },
    });
};

export const useResolveEncounterMutation = () => {
    const queryClient = useQueryClient();
    return useMutation<
        unknown, // Response type
        unknown, // Error type
        { encounter_id: string; program?: string } // Variables type
    >({
        mutationFn: async ({ encounter_id, program = "urgent_care" }) => {
            try {
                const response = await apiClient(
                    `/admin/encounters/${encounter_id}/resolve?program=${encodeURIComponent(program)}`,
                    {
                        method: "POST",
                    }
                );
                return await handleResponse(response);
            } catch (error) {
                return handleError(error);
            }
        },
        onSuccess: (_, variables) => {
            // const apiProgram = variables.program || "urgent_care";
            toast.success("Encounter resolved successfully!");
            // Invalidate encounter queries
            queryClient.invalidateQueries({ queryKey: encountersKeys.encounterById(variables.encounter_id) });
            queryClient.invalidateQueries({ queryKey: encountersKeys.all });
            queryClient.invalidateQueries({ queryKey: quickActionsKeys.all });
        },
    });
};





